import { Controller } from '@hotwired/stimulus'
import Cleave from 'cleave.js'

export default class extends Controller {
  static targets = [
    'numeral',
    'date'
  ]

  numeralTargetConnected (target) {
    target.cleave = new Cleave(target, {
      numeral: true,
      delimiter: ' ',
      prefix: target.dataset.prefix,
      tailPrefix: target.dataset.tailPrefix !== 'false',
      numeralPositiveOnly: true,
      numeralThousandsGroupStyle: 'thousand',
      numeralDecimalScale: target.dataset.numeralDecimalScale || 2
    })
  }

  numeralTargetDisconnected (target) {
    target.cleave?.destroy()
  }

  dateTargetConnected (target) {
    const originalValue = target.value

    // Create an  hidden input to store the raw value
    target.hiddenInput = document.createElement("input")
    target.hiddenInput.type = "hidden"
    target.hiddenInput.name = target.name
    target.hiddenInput.value = target.value
    target.parentNode.insertBefore(target.hiddenInput, target.nextSibling)

    target.cleave = new Cleave(target, {
      date: true,
      delimiter: target.dataset.delimiter || " / ",
      datePattern: target.dataset.datePattern || ['d', 'm', 'Y']
    })

    if (originalValue) {
      const date = new Date(originalValue)
      target.cleave.setRawValue(date.toLocaleDateString("fr-FR"))
    }

    target.cleave.properties.onValueChanged = () => {
      target.hiddenInput.value = target.cleave.getISOFormatDate()
    }
  }

  dateTargetDisconnected (target) {
    target.cleave?.destroy()
  }
}
